import { render } from "./forward.vue?vue&type=template&id=7fb221f1"
import script from "./forward.vue?vue&type=script&lang=js"
export * from "./forward.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__